<template>
  <div class="hx-login-container">
    <div class="hx-login-bg-top">
      <div class="hx-login-logo">
        <img src="static/images/login-logo.png" alt="" />
      </div>
    </div>
    <div class="hx-login-bg-footer"></div>
    <div class="hx-login-template">
      <el-form
        class="hx-login-template-form"
        label-width="80px"
        ref="loginForm"
        :model="listParams"
        :rules="checkListParams"
      >
        <el-form-item prop="username" label="账号：">
          <el-input
            placeholder="请输入账号"
            v-model="listParams.username"
            :maxlength="30"
            class="input"
          />
        </el-form-item>

        <el-form-item prop="password" label="密码：">
          <el-input
            @keyup.native.13="login('loginForm')"
            placeholder="请输入密码"
            v-model="listParams.password"
            :maxlength="18"
            type="password"
            class="input"
          />
        </el-form-item>

        <el-form-item prop="smsCode" label="验证码：">
          <el-input
            :maxlength="6"
            placeholder="请输入验证码"
            v-model="listParams.smsCode"
            class="input"
          >
            <template slot="append">
              <el-button
                class="inputBtn"
                :disabled="sendLoading || countDownTime > 0"
                :loading="sendLoading"
                @click="handleSendSmsCode"
              >
                <span v-if="countDownTime > 0">{{ countDownTime }}s</span>
                <span v-else class="color-primary">短信验证</span>
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            :disabled="buttonLoading"
            :loading="buttonLoading"
            class="btnPriamry"
            type="primary"
            @click="login('loginForm')"
          >
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import JSEncrypt from "jsencrypt";
import SHA256 from "crypto-js/sha256";

// -----BEGIN PUBLIC KEY-----
// MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOAY5PQi8XcZnhxfZwWjNrFWSZ/hZlEx
// g3f43CREwNFv8ARxdDVh8hHHDoSeDg9SuCREWVWGuK6L4B4C/gFKa6UCAwEAAQ==
// -----END PUBLIC KEY-----

const PublicKey =
  "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOAY5PQi8XcZnhxfZwWjNrFWSZ/hZlExg3f43CREwNFv8ARxdDVh8hHHDoSeDg9SuCREWVWGuK6L4B4C/gFKa6UCAwEAAQ==";

const signatureKey =
  "K8#pL2xQ!rT9$sH4vB7^mN6*zR3wE5tG1";

export default {
  data() {
    return {
      listParams: {
        username: "",
        password: "",
        smsCode: ""
      },
      sendLoading: false,
      buttonLoading: false,
      checkListParams: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            // message: "请输入密码(8-18位，包含数字、字母和特殊字符!@#$%^&*)",
            // pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/i,
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码(6位)",
            trigger: "blur",
            pattern: /^\d{6}$/
          }
        ]
      },
      timeOutId: null,
      countDownTime: 0
    };
  },

  mounted() {
    localStorage.clear();
    const params = this.getRequest();
    this.listParams.username = params.username;
    this.listParams.password = params.password;
    if (this.listParams.username && this.listParams.password) {
      this.login("loginForm");
    }
  },

  destroyed() {
    clearTimeout(this.timeOutId);
  },

  methods: {
    /**
     * 发送短信验证码
     */
    async handleSendSmsCode() {
      const username = this.listParams.username;
      if (username) {
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(PublicKey);
        const usernameEncord = encrypt.encrypt(username);
        const timestamp = new Date().getTime() + "";
        const signature = SHA256(usernameEncord + timestamp + signatureKey);
        try {
          this.sendLoading = true;
          const response = await this.$http({
            url: `${global.apiUrl}/admin/login/sms/code`,
            method: "POST",
            body: { userName: usernameEncord, signature: signature.toString(), timestamp: timestamp }
          });
          const result = response.body || {};
          this.sendLoading = false;
          if (result.sysStatus === 0 && result.apiStatus === 0) {
            this.countDownTime = 60;
            this.timeOutId = setInterval(() => {
              if (this.countDownTime > 0) {
                this.countDownTime -= 1;
              } else {
                clearInterval(this.timeOutId);
              }
            }, 1000);
          } else {
            this.countDownTime = 0;
          }
        } catch (error) {
          this.sendLoading = false;
          this.countDownTime = 0;
        }
      } else {
        this.$message.warning("请输入账号！");
      }
    },
    /**
     * 登录
     * @param {} name
     */
    login(name) {
      this.buttonLoading = true;
      const bodyParams = Object.assign({}, this.listParams);
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(PublicKey);
      bodyParams.username = encrypt.encrypt(bodyParams.username);
      bodyParams.password = md5(bodyParams.password).toUpperCase();
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/admin/operation/login",
            method: "POST",
            body: bodyParams
          })
            .then(response => {
              const result = response.body || {};
              if (result.sysStatus === 0 && result.apiStatus === 0) {
                this.buttonLoading = false;
                if (result.data) {
                  localStorage.setItem("TOKEN", result.data.token);
                  localStorage.setItem("username", result.data.username);
                  this.$router.push({ name: "supplySystem" });
                }
              } else {
                this.buttonLoading = false;
                this.$refs.loginForm.resetFields();
              }
            })
            .catch(err => {
              this.buttonLoading = false;
              console.error(err);
            });
        } else {
          this.buttonLoading = false;
        }
      });
    },
    /**
     * 获取路径参数
     */
    getRequest() {
      const url = location.search; // 获取url中"?"符后的字串
      const theRequest = {};
      if (url.indexOf("?") !== -1) {
        const str = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
  }
};
</script>

<style lang="less" scoped>
.hx-login-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .hx-login-bg-top {
    overflow: hidden;
    width: 100%;
    height: 300px;
    background: linear-gradient(-100deg, #008080, #1b6f49);
    .hx-login-logo {
      width: 500px;
      height: 200px;
      margin: 30px auto;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
  .hx-login-bg-footer {
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .hx-login-template {
    width: 410px;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin: -50px auto;
    z-index: 9999;
    background: #ffffff;
    position: relative;
    padding: 70px 30px 30px 50px;
    .hx-login-template-form {
      .input {
        width: 300px;
      }
      .inputBtn {
        width: 100px;
      }

      .color-primary {
        color: teal !important;
      }
      .btnPriamry {
        width: 300px;
        margin-top: 10px;
        background-color: teal;
        border-color: teal;
      }
    }
  }
}
</style>
